import api from './api';

export const razorpayService = {
  /**
   * Create a Razorpay order on the backend
   * @param {number} amount - Amount in paise (e.g., ₹500 = 50000 paise)
   * @param {string} currency - Currency code (default: INR)
   * @param {string} receipt - Unique receipt ID
   * @returns {Promise<{order_id: string, amount: number, currency: string}>}
   */
  createOrder: async (amount, currency = 'INR', receipt = null) => {
    const response = await api.post('/razorpay/create-order', {
      amount,
      currency,
      receipt: receipt || `receipt_${Date.now()}`
    });
    return response.data;
  },

  /**
   * Verify Razorpay payment signature on the backend
   * @param {string} razorpay_order_id
   * @param {string} razorpay_payment_id
   * @param {string} razorpay_signature
   * @returns {Promise<{success: boolean, data: {isPaid: boolean}}>}
   */
  verifyPayment: async (razorpay_order_id, razorpay_payment_id, razorpay_signature) => {
    const response = await api.post('/razorpay/verify-payment', {
      razorpay_order_id,
      razorpay_payment_id,
      razorpay_signature
    });
    return response.data;
  }
};

